<template>
  <b-modal v-model="showAccountModal" :title="modalTitle" size="lg">
    <div v-if="isLoadingModal" class="block block-mode-loading bg-body-dark">
      <br><br><br><br><br><br><br><br><br>
    </div>
    <div v-else>
      <div class="text-center">
        <div class="form-group row items-push mb-0 pb-0">
          <div class="col-md-12">
            <div class="btn-group" role="group" aria-label="Search Option Accumulated">
              <button @click="setAccumulated(true)" type="button" class="btn btn-primary" :class="[{ 'active': accumulated }]">{{$t('networkTransfers.accountInfoModal.accumulated')}}</button>
              <button @click="setAccumulated(false)" class="btn btn-primary" :class="[{ 'active': !accumulated }]">{{$t('networkTransfers.accountInfoModal.singleTxs')}}</button>
            </div>
          </div>
        </div>
      </div>
      <transfer-details v-for="(transfer, index) in modal.data.transfers" :transfer="transfer" :account="modal.params.account[0]" :key="index" />
    </div>
  </b-modal>
</template>

<script>
import TransferDetails from '@/components/common/TransferDetails'

export default {
  components: {
    TransferDetails
  },
  computed: {
    modal () {
      return this.$store.state.network.modal
    },
    showAccountModal: {
      get () {
        return this.modal.nodeModalShow
      },
      set (value) {
        this.$store.commit('toggleNodeModal', value)
      }
    },
    modalTitle () {
      if (this.isLoadingModal) {
        return this.$t('networkTransfers.accountInfoModal.loading')
      } else return this.$t('networkTransfers.accountInfoModal.selectedNode') + ' ' + this.modal.params.account[0]
    },
    isLoadingModal () {
      return this.$store.state.options.isLoadingModal
    }
  },
  data () {
    return {
      accumulated: true
    }
  },
  methods: {
    setAccumulated (accumulated) {
      this.$store.dispatch('loadAccountData', { account: this.modal.params.account, direction: null, accumulated: accumulated })
      this.accumulated = accumulated
    }
  }
}
</script>

<style>
  .modal-body {
    background-color: rgb(235, 235, 235) !important;
  }
</style>
